<template>
  <section class="section--comp">
    <div class="container items-left">
      <h3 class="section--h3">Our Mission</h3>
      <p class="section--p">
        Help you in Developing Careers & Companies
      </p>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col
          class="sm:w-full lg:w-2/5 mb-base"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <div>
            <h3 class="mission_sub ind mb-2">For Individuals</h3>
            <p class="mission__p mb-1">
              Provide portfolio building & personality assessments platfrom for
              students
            </p>
          </div>
        </vs-col>
        <vs-col
          class="sm:w-full lg:w-2/5 mb-base"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <div>
            <h3 class="mission_sub org mb-2">For Organizations</h3>
            <p class="mission__p mb-1">
              Provide a simple yet effective tool (SASS) for universities &
              companies to profile, search and place talent
            </p>
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="img" vs-type="flex" vs-justify="space-between">
        <vs-col
          class="sm:w-full lg:w-2/5 mb-base"
        >
          <img
                      src="@/assets/images/aboutUs/ind1.png"
                      alt="About Us"
                    />
        </vs-col>
        <vs-col
          class="sm:w-full lg:w-2/5 mb-base"
        >
                    <img
                      src="@/assets/images/aboutUs/org1.png"
                      alt="About Us"
                    />
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
export default {
  name: "Mission",
};
</script>

<style scoped>
/*===============================================*/
/* OUR MISSION	 						 */
/*===============================================*/

.mission-card {
  min-height: 135px;
}
.section--h3{
    font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 170%;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #44cc88;
}
.img >>> img {
  border-radius: 10px;
}
.section--p{
    font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 140%;
  color: #121127;
}
.mission_sub {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 140%;
  color: #444bd3;
}
.mission_heading {
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 140%;
  color: #121127;
}

.truncate {
  width: 80%;
  white-space: normal !important;
  margin-left: 1.5rem;
}
.mission__p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 29px */

  color: #5d6473;
}
.section--comp {
  background: #f7f8f9;
}

/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 992px) {
  .img >>> img {
    height: 200px;
  }
}
</style>
